<template>
  <span>
    <template v-if="isTooltipBtn">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon :loading="loading" @mouseover="onMouseOverTooltip()" @click="nextLoadData && nextLoadData.nextLoadId ? $root.onShowLoadPreview(nextLoadData.nextLoadId, 0, true) : null">
              <v-icon small>mdi-debug-step-over</v-icon>
            </v-btn>
        </template>
        <span v-if="nextLoadData && nextLoadData.nextLoadId > 0">
          {{$t('Loads.NextLoadForTruck', {truckName: nextLoadData.truckName})}}:&nbsp;#{{nextLoadData.nextLoadId}}&nbsp;{{nextLoadData.pickupLocationName}} -- {{nextLoadData.deliveryLocationName}}&nbsp;|&nbsp;{{nextLoadData.dispatcherName}}
        </span>
        <span v-else>
          {{ loading ? $t('Loading') : $t('Loads.NoTruckNextLoad')}}
        </span>
      </v-tooltip>
    </template>
    <template v-else-if="nextLoadData && nextLoadData.nextLoadId > 0">
      <v-icon small>mdi-chevron-right</v-icon>{{$t('Loads.NextLoadForTruck', {truckName: nextLoadData.truckName})}}:&nbsp;<a @click.stop="$root.onShowLoadPreview(nextLoadData.nextLoadId, truckId, true)">
      #{{nextLoadData.nextLoadId}}
      &nbsp;{{nextLoadData.pickupLocationName}} -- {{nextLoadData.deliveryLocationName}}</a>&nbsp;|&nbsp;{{nextLoadData.dispatcherName}}
    </template>
  </span>
</template>

<script>
export default {
  name: 'NextTruckLoadSnippet',
  props: ['currentLoadId', 'truckId', 'isTooltipBtn'],
  data: function () {
    return {
      loading: false,
      isFetched: false,
      nextLoadData: {}
    };
  },
  computed: {
    avatarLetters () {
      if (this.userData.firstName && this.userData.lastName) {
        return this.userData.firstName[0] + this.userData.lastName[0];
      }
      return false;
    },
    fullName () {
      return this.userData.firstName + ' ' + this.userData.lastName;
    }
  },
  mounted () {
    if (!this.isTooltipBtn) {
      this.fetchData();
    }
  },
  methods: {
    onMouseOverTooltip () {
      if (!this.isFetched) {
        this.fetchData();
      }
    },
    fetchData () {
      this.loading = true;
      this.$root.getTruckNextLoad(this.truckId, this.currentLoadId).then((response) => {
        if (response.status === 'ok') {
          this.nextLoadData = response;
          this.isFetched = true;
        }
        this.loading = false;
      });
    }
  }
};
</script>
